<template>
  <div class="box">
    <!-- 区级账号 -->
    <div v-if="org_type =='1' ">
      <el-select
        size="small"
        v-model="selectParams.yearly_semester"
        placeholder="学年学期"
        class="label"
      >
        <el-option
          v-for="item in dataList_1"
          :key="item.val + 'xq'"
          :label="item.label"
          :value="item.label"
          @click.native="rightClick(item, 'xq')"
        >
        </el-option>
      </el-select>
      <el-select
        size="small"
        v-model="selectParams.prd_id"
        placeholder="学段"
        class="label"
      >
        <el-option
          v-for="item in dataList_3"
          :key="item.val + 'xd'"
          :label="item.label"
          :value="item.val"
          @click.native="rightClick(item, 'xd')"
        >
        </el-option>
      </el-select>
      <el-select
        size="small"
        v-model="selectParams.qy"
        placeholder="区域"
        class="label"
        filterable
      >
        <el-option
          v-for="item in dataList_2"
          :key="item.val + 'qy'"
          :label="item.label"
          :value="item.val"
          @click.native="rightClick(item, 'qy')"
        >
        </el-option>
      </el-select>
      
      <el-button type="primary" size="small" @click="onConfirm">搜索</el-button>
    </div>
    <div v-if="org_type =='2' ">
      <el-select
        size="small"
        v-model="selectParams.yearly_semester"
        placeholder="学年学期"
        class="label"
      >
        <el-option
          v-for="item in dataList_1"
          :key="item.val + 'xq'"
          :label="item.label"
          :value="item.label"
          @click.native="rightClick(item, 'xq')"
        >
        </el-option>
      </el-select>
      <el-button type="primary" size="small" @click="onConfirm">搜索</el-button>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import util from "@/utils/util.js";
export default {
  name: "name",
  components: {},
  props: {
    type: {
      default: "",
      type: String,
    },
  },
  data() {
    return {
      selectList: [
        { label: "学期", val: "xq" },
        { label: "区域", val: "qy" },
        { label: "学段", val: "xd" },
      ],
      dataList_1: [
        { label: "2021-2022学年上学期", val: "2021-2022学年上学期" },
        { label: "2021-2022学年下学期", val: "2021-2022学年下学期" },
        { label: "2022-2023学年上学期", val: "2022-2023学年上学期" },
        { label: "2022-2023学年下学期", val: "2022-2023学年下学期" },
        { label: "2023-2024学年上学期", val: "2023-2024学年上学期" },
        { label: "2023-2024学年下学期", val: "2023-2024学年下学期" },
      ],
      dataList_2: [],
      dataList_3: [
        { label: "全学段", val: "" },
        { label: "小学", val: "xx" },
        { label: "初中", val: "cz" },
      ],
      selectParams: {
        yearly_semester:util.getYearlySemester()|| "2023-2024学年上学期", //学期
        qy: "", //区域id
        prd_id: "", //学段id
        prd_name: "", //学段名称
        orga_id: "", //学校id
        orga_name: "", //学校名称
        coun_code: "", //区编码
        coun_name: "", //区名称
        city_code: "", //市编码
        city_name: "", //市名称
        prov_code: "", //省编码
        prov_name: "", //省名称
      },
      org_type: sessionStorage.org_type, // 1:教育局, 2:学校, 8:机构
      user_level: sessionStorage.user_level, // 教育局级别判断	省级:99  市级:1,10  区县级:2,20,4,40
      primary_school: JSON.parse(sessionStorage.primary_school || "[]"), // 小学列表
      junior_high_school: JSON.parse(sessionStorage.junior_high_school || "[]"), // 初中列表
      areaList: JSON.parse(sessionStorage.areaList || "[]"), // 市, 区列表
      all_school: [], // 全部学校-小学+初中
      school_1: [], // 小学
      school_2: [], // 初中
    };
  },
    computed: {
    ...mapState(["isSchool"]),
  },
  watch: {
    "selectParams.prd_name": function (n, o) {
      if (["2", "20", "4", "40"].indexOf(this.user_level) > -1) {
        // 区级切换学段显示不同学段的学校列表
        if (n === "小学") {
          this.dataList_2 = this.school_1;
        } else if (n === "初中") {
          this.dataList_2 = this.school_2;
        } else {
          this.dataList_2 = this.all_school;
        }
        this.selectParams.qy = ""
        this.selectParams.orga_id = "";
        this.selectParams.orga_name = "";
      }
    },
  },
  mounted() {},
  created() {
    this.init();
  },
  methods: {
    init() {
      if (this.org_type === "1") {
        // 教育局
        if (this.user_level === "99") {
          // 省级
          let list = this.areaList.map((e) => {
            return {
              label: e.area_name,
              val: e.area_code,
            };
          });
          this.dataList_1 = [{ label: "全省", val: "" }].concat(list);
        } else if (["1", "10"].indexOf(this.user_level) > -1) {
          // 市级
          let list = this.areaList.map((e) => {
            return {
              label: e.area_name,
              val: e.area_code,
            };
          });
          this.dataList_2 = [{ label: "全市", val: "" }].concat(list);
        } else if (["2", "20", "4", "40"].indexOf(this.user_level) > -1) {
          // 区级
          let list = this.primary_school
            .concat(this.junior_high_school)
            .map((e) => {
              return {
                label: e.org_name,
                val: e.org_id,
              };
            });
          // 小学列表
          this.school_1 = [{ label: "全区", val: "" }].concat(
            this.primary_school.map((e) => {
              return {
                label: e.org_name,
                val: e.org_id,
              };
            })
          );
          // 初中列表
          this.school_2 = [{ label: "全区", val: "" }].concat(
            this.junior_high_school.map((e) => {
              return {
                label: e.org_name,
                val: e.org_id,
              };
            })
          );
          this.dataList_2 = [{ label: "全区", val: "" }].concat(list);
          this.all_school = this.dataList_2;
        }
      }
    },
    rightClick(item, type) {
      console.log("选择", item, type);
      switch (type) {
        case "xq":
          this.selectParams.yearly_semester = item.label;
          break;
        case "qy":
          if (item.val) {
            if (this.user_level === "99") {
              // 省级
              this.selectParams.city_code = item.val;
              this.selectParams.city_name = item.label;
            } else if (["1", "10"].indexOf(this.user_level) > -1) {
              // 市级
              this.selectParams.coun_code = item.val;
              this.selectParams.coun_name = item.label;
            } else if (["2", "20", "4", "40"]) {
              // 区级
              this.selectParams.orga_id = item.val;
              this.selectParams.orga_name = item.label;
            }
          } else {
            this.selectParams.prov_code = "";
            this.selectParams.prov_name = "";
            this.selectParams.city_code = "";
            this.selectParams.city_name = "";
            this.selectParams.coun_code = "";
            this.selectParams.coun_name = "";
            this.selectParams.orga_id = "";
            this.selectParams.orga_name = "";
          }
          this.selectParams.qy = item.val;
          break;
        case "xd":
          this.selectParams.prd_id = item.val;
          this.selectParams.prd_name = item.label;
          break;
      }
      console.log(this.selectParams);
      this.onConfirm()
    },
    onConfirm() {
      this.$emit("selectOk", JSON.parse(JSON.stringify(this.selectParams)));
    },
  },
};
</script>

<style lang="less" scoped>
.box {
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  ::v-deep .el-input {
    width: 200px;
    margin-right: 10px;
  }
}
</style>
